import {Component, input, output} from '@angular/core'
import {MatIconButton} from '@angular/material/button'
import {MatIcon} from '@angular/material/icon'
import {IDocument} from '@sparbanken-syd/user-documents-backend'
import {DocumentNameComponent} from '../document-name/document-name.component'

@Component({
  selector: 'spb-selected',
  templateUrl: './selected.component.html',
  styleUrl: './selected.component.scss',
  imports: [
    MatIcon,
    DocumentNameComponent,
    MatIconButton
  ]
})
export class SelectedComponent {
  /**
   * If you want to delete pass a function.
   */
  public remove = output<string>()

  public color = input<string>('#E0E0E0')

  public document = input.required<IDocument>()

  public removable = input<boolean>(true)
}
